module.exports = __webpack_public_path__ + "static/media/Sun-Shine.3900cdaa.png";